import axios from 'axios';
import Vue from "vue";
Vue.prototype.axios = axios;
Vue.prototype.axios.defaults.withCredentials = true;

//基本请求1
const instance = axios.create({
    //baseURL: "/api",
    baseURL: "http://39.106.131.206:8090",
    timeout: 5000
});

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

//导出axios实例
export default instance
